import { createFileRoute, Navigate } from '@tanstack/react-router';
import { type ReactElement } from 'react';

export const Route = createFileRoute('/_app/settings/agent-skills')({
    component: AgentSkillsRedirect,
});

function AgentSkillsRedirect(): ReactElement {
    return (
        <Navigate
            to="/settings/configurations"
            search={{ tab: 'skills' }}
            replace={true}
        />
    );
}
